module.exports = __webpack_public_path__ + "img/muslim-kids-school.bc5e3842.jpg";